export default __webpack_public_path__ + "static/media/spindex-banner-inner-mob.ae7f4af6.jpg";